import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { ValidatorFn } from '@angular/forms';

import { MessageComponent, SpinnerComponent } from '@recruitee/user-interface';

import { Destroyable, takeUntilDestroyed } from '../../../common';
import { DynamicFormLoaderConfig } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';
import { DynamicFormResourcesService } from '../dynamic-form/dynamic-form-resources.service';

const alwaysFalseValidator = (_: any): {} => ({ formLoader: true });

export class FormLoaderInput extends DynamicFormInput<DynamicFormLoaderConfig> {
  protected validators(): ValidatorFn[] {
    return super.validators().concat([alwaysFalseValidator]);
  }
}

@Component({
  selector: 'rti-form-loader-input',
  templateUrl: './form-loader-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MessageComponent, SpinnerComponent],
})
@Destroyable()
export class FormLoaderInputComponent {
  @Input() public input: FormLoaderInput;

  public loading: boolean = true;
  public errors: string[] = [];

  constructor(
    private cdRef: ChangeDetectorRef,
    private resourcesSvc: DynamicFormResourcesService,
  ) {}

  public ngOnInit(): void {
    this.resourcesSvc.loading$.pipe(takeUntilDestroyed(this)).subscribe(loading => {
      this.loading = loading;
      this.cdRef.detectChanges();
    });

    this.resourcesSvc.formError$.pipe(takeUntilDestroyed(this)).subscribe(error => {
      this.errors = error;
      this.cdRef.detectChanges();
    });
  }

  public trackByErrorMessage(_index: number, error: string): string {
    return error;
  }
}
